const UA = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/

export function isMobile() {  
  return navigator.userAgent.match(UA) !== null
}
